import React, { useEffect, useState } from "react";
import axios from "axios";
import { MdBarChart, MdShowChart } from "react-icons/md";
import { PiChartLineDownBold } from "react-icons/pi";
import {
  FaRupeeSign,
  FaArrowUp,
  FaArrowDown,
  FaChartLine,
  FaChartBar,
  FaProjectDiagram,
} from "react-icons/fa";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  LineChart,
  Line,
  CartesianGrid,
  Legend,
  ComposedChart,
} from "recharts";
import { BsBuilding } from "react-icons/bs";
import { useParams } from "react-router-dom";

const NiftyDetail = () => {
  const { symbol, id } = useParams();
  const [intraday, setIntraday] = useState(null); // intraday for stock
  const [livestock, setLiveStock] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchIntraday = async () => {
      if (!id) return;

      try {
        setLoading(true);
        const response = await axios.post(
          "http://localhost:8000/api/intraday",
          {
            stock_id: id, // ✅ pass tickerId
          }
        );
        setIntraday(response.data);
        console.log("Intraday Data:", response.data);
      } catch (err) {
        console.error("Error fetching intraday:", err);
      } finally {
        setLoading(false);
      }
    };
    // const fetchLiveStock = async () => {
    //   try {
    //     setLoading(true);

    //     const response = await axios.post("http://localhost:8000/api/nsedata", {
    //       stock_symbols: [symbol.trim()],
    //     });
    //     setLiveStock(response.data[stockName]);
    //   } catch (err) {
    //     console.log("Error is:-", err);
    //   } finally {
    //     setLoading(false);
    //   }
    // };

    fetchIntraday();
    // fetchLiveStock();
  }, [id, symbol]);

  console.log("Intraday Data:-", intraday);
  console.log("Live data:-", livestock);
  return (
    <>
      <div></div>
    </>
  );
};

export default NiftyDetail;
